module.exports = __webpack_public_path__ + "img/greyacquadiparma.891c795f.webp";